import {DOM} from "../helpers/DOM.js";

export class DonationsForm{
	#otherAmountToggle;
	#otherAmountField;

	#variationsWrapper;

	constructor() {
		this.#otherAmountToggle = document.getElementById('other_amount_toggle');
		this.#otherAmountField = document.querySelector('div.levcharity_form__donation_amount.custom_amount');

		this.#variationsWrapper = document.querySelector('.donation_variations');
	}
	watchOtherAmountToggle(){
		if(this.#otherAmountToggle){
			this.#otherAmountToggle.addEventListener('change', event => {
				this.#otherAmountField.style.display = this.#otherAmountToggle.checked ? '' : 'none';
			})
		}
	}

	watchVariationsChange() {
		if (this.#variationsWrapper) {
			DOM.addEvent('input,focus', 'input[type="number"]', (event, target) => {
				DOM.els('input[type="radio"]', this.#variationsWrapper)
					.forEach(radio => {
						radio.checked = false;
					});

				target.required = true;

				const checkbox = DOM.el('input[type="checkbox"]', target.closest('.variation_other_amount_wrapper'));

				if (checkbox){
					checkbox.checked = true;
				}

			}, this.#variationsWrapper, true);
			DOM.addEvent('change', 'input[type="radio"]', (event, target) => {
				DOM.els('input[type="number"]', this.#variationsWrapper)
					.forEach(input => {
						input.required = false;
						const checkbox = DOM.el('input[type="checkbox"]', input.closest('.variation_other_amount_wrapper'));

						if (checkbox){
							checkbox.checked = false;
						}
					});
			}, this.#variationsWrapper);


			DOM.addEvent('input', '.variation_quantity input[type="number"]', (event, target) => {
				const parentContainer = target.closest('.form-field.variation_checkbox_form_field');
				if (parentContainer) {
					const checkbox = parentContainer.querySelector('input[type="radio"].donation_variation_checkbox') ? parentContainer.querySelector('input[type="radio"].donation_variation_checkbox') : parentContainer.querySelector('input[type="checkbox"].donation_variation_checkbox');
					if (checkbox) {
						if (target.value > 0) {
							checkbox.checked = true;
						}else {
							checkbox.checked = false;
						}
					}
				}
			}, this.#variationsWrapper);

			DOM.addEvent('focusin', 'input[type="number"]', (event) => {
				const allInputs = document.querySelectorAll('.variation_quantity input[type="number"]');
				if(allInputs) {
					allInputs.forEach((input) => {
						const parentContainer = input.closest('.form-field.variation_checkbox_form_field');
						if (parentContainer) {
							const checkbox = parentContainer.querySelector('input[type="radio"].donation_variation_checkbox');
							if (checkbox) {
								checkbox.checked = parseFloat(input.value) > 0;
							}
						}
					});
				}
			}, this.#variationsWrapper);

		}
	}
}
